module.exports = __webpack_public_path__ + "static/media/logo192.e59856af.png";